import { Api } from '../AApi'

export const API_TASK = new Api(
  {
    url: 'tasks',
    isConvertFormData: false,
  },
  {}
)
